
import { defineComponent, reactive, onMounted, computed, ref, watch, onBeforeUnmount, toRaw, nextTick } from "vue";
import { ethitransService } from "@/services/EthitransService";
import ErrorList from "@/components/commonDesign/ErrorList.vue";
import DragAndDropZone from "@/common/DragAndDropZone.vue";
import { validationService } from "@/common/ValidationService";
import { common } from "@/common/services/Common";
import { config } from "@/Config";
import Multiselect from "vue-multiselect";
import { useRoute, useRouter, onBeforeRouteLeave } from "vue-router";
import SuccessfulModalCustom from "@/components/modal/SuccessfulModalCustom.vue";
import Editor from "@/components/mention/Editor.vue";
import SendEstimationInvitationAddPhaseModal from "@/components/todo/SendEstimationInvitationAddPhaseModal.vue";
import AppDeleteConfirmationModal from "@/common/AppDeleteConfirmationModal.vue";
import SignaturePadModal from "@/components/modal/SignaturePadModal.vue";
import SignatureUploadModal from "@/components/modal/SignatureUploadModal.vue";
import { useI18n } from 'vue-i18n';
import cloneDeep from 'lodash/cloneDeep';
import { useUnsavedChanges } from "../composables/useUnsavedChanges";

export default defineComponent({
  name: "ProjectWorkflowSendEstimationInvitaion",
  props: {
    estimationId: {
      type: String,
      required: true,
    },
  },
  components: {
    AppDeleteConfirmationModal,
    DragAndDropZone,
    ErrorList,
    Multiselect,
    SuccessfulModalCustom,
    SendEstimationInvitationAddPhaseModal,
    Editor,
    SignaturePadModal,
    SignatureUploadModal
  },
  setup(props, { emit, expose }) {
    const { t } = useI18n();
    const router = useRoute();
    const route = useRouter();
    const isInvalid = ref(false);
    const canvas: any = ref(null);
    const signaturePad: any = null;
    const customStartDate = ref('') as any;
    const customEndDate = ref('') as any;
    const signatureInput = ref<HTMLInputElement | null>(null);

    const state = reactive({
      data: {
        haveProfileSign: false,
        useProfileSign: false,
        showSignaturePad: false,
        showSignatureUpload: false,
        uploadSignatureFile: "" as any,
        signatureLink: "" as any,
        totalProjectDays: "",
        deleteModalMessage:
          t('confirm_delete_phase'),
        isActiveEdocLink: false,
        showDeletePhaseConfirmation: false,
        selectedforDelete: {},
        cropImage: "",
        timeCount: 130,
        cropSignature: "" as any,
        newUploadImge: "" as any,
        projectId: "" as any,
        estimationId: "" as any,
        showSuccesCustomModal: false,
        imageBaseUrl: "",
        successFulMessage: "",
        todayData: new Date() as any,
        removeUser: {} as any,
        sendPhases: [] as any,
        approveByAll: false,
        signatureFileName: "" as any,
        showAddPhaseModal: false,
        editMode: false,
        editFrom: "" as any,
        selectedIndex: "" as any,
        selectedTaskIndex: "" as any,
        editData: {} as any,
        uploadSignature: "" as any,
        selectedItemList: [] as any,
        estimation: {} as any,
        companyInfo: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          company_name: "",
          // eslint-disable-next-line @typescript-eslint/camelcase
          company_email: "",
          // eslint-disable-next-line @typescript-eslint/camelcase
          company_phone_number: "",
          // eslint-disable-next-line @typescript-eslint/camelcase
          company_address: "",
          acknowledgement: "",
          // eslint-disable-next-line @typescript-eslint/camelcase
          legal_statement: "",
          // eslint-disable-next-line @typescript-eslint/camelcase
          logo: "",
        },
        projectEstimations: {
          customer: "",
          customersList: [] as any,
          name: "",
          description: "",
          estimatedBudget: "" as any,
          startDate: "",
          endDate: "",
          attachments: [] as any,
          edocLink: "",
        },
        allCustomer: [] as any,
        selectedCustomers: [] as any,
        sendarSignature: "" as any,
        sendarSignatureFileLink: "" as any,
        createPhase: [] as any,
        tempPhase: [] as any,
      },
      projectDate: {
        type: '',
        value: '',
        startDate: null,
        endDate: null
      } as any,
      ui: {
        isLoading: {
          isCompanyEdit: false,
          projectDetailsAPICalled: false,
          enableEndDate: true,
          isEdit: false,
          loadDetailsData: false,
          signaturePadLoad: false,
          projectStartDate: false,
          projectEndDate: false,
          isReadyToSend: false,
          getSmartContractDetails: false,
          projectDate: false

        },
        isPostLoading: {
          removeSelectedImage: false,
          sendEstimation: false,
          saveEstimation: false,
          delete: false,
          updateEstimation: false,
          checkSignature: false,
          createCompanyIfno: false,
        },
        errors: {
          errorList: {
            approval: [] as any,
            createCompanyIfno: [] as any,
          },
          hasError: false,
        },
      },
    });

    const originalState = ref(cloneDeep(toRaw(state.data)));
    // const hasUnsavedChanges = ref(false);
    const { hasUnsavedChanges, markAsDirty, markAsSaved } = useUnsavedChanges(() => cloneDeep(toRaw(state.data)));

    watch(
      () => state.data,
      (newVal) => {
        // hasUnsavedChanges.value = true;
        markAsDirty();
      },
      { deep: true }
    );
    expose({
      hasUnsavedChanges
    });
    const handleBeforeUnload = (event: any) => {
      if (hasUnsavedChanges.value) {
        event.preventDefault();
        event.returnValue = ''; // for most browsers
        return ''; // for older browsers
      }
    };

    const numberLabel = computed(() => {
      switch (state.projectDate.type) {
        case '1': return 'No. of Days'
        case '2': return 'No. of Weeks'
        case '3': return 'No. of Months'
        default: return 'Number'
      }
    })

    const handleDateTypeChange = () => {
      if (state.projectDate.type === '5') {
        // eslint-disable-next-line @typescript-eslint/camelcase
        customStartDate.value = state.projectDate.startDate
        // eslint-disable-next-line @typescript-eslint/camelcase
        customEndDate.value = state.projectDate.endDate
        $("#inviteMemberCustomValidity").modal("show")
      }
    }

    const hideCustomValidity = () => {
      $("#inviteMemberCustomValidity").modal("hide")
    }


    const saveCustomDaysToselectedMember = () => {
      // eslint-disable-next-line @typescript-eslint/camelcase
      state.projectDate.startDate = common.localDateOnly(customStartDate.value)
      // eslint-disable-next-line @typescript-eslint/camelcase
      state.projectDate.endDate = common.localDateOnly(customEndDate.value)
      hideCustomValidity()
    }

    const acknowledgement = computed({
      get() {
        return state.data.estimation.acknowledgement || state.data.companyInfo.acknowledgement;
      },
      set(value: any) {
        state.data.estimation.acknowledgement = value;
      }
    });

    const legalStatement = computed({
      get() {
        return state.data.estimation.legal_statement || state.data.companyInfo.legal_statement;
      },
      set(value: any) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        state.data.estimation.legal_statement = value;
      }
    });
    function showSignaturePad() {
      state.data.showSignaturePad = !state.data.showSignaturePad;
    }

    function hideSignaturePad() {
      state.data.showSignaturePad = !state.data.showSignaturePad;
      $("#signaturePadModal").modal("hide");
    }

    // function hideSignatureUpload() {
    //   state.data.showSignatureUpload = false;
    //   $("#signatureUploadModal").modal("hide");
    // }
    function hideSignatureUpload() {
      state.data.showSignatureUpload = false;
      if (signatureInput.value) {
        signatureInput.value.value = '';
      }
    }
    function uploadSignature(data: any) {
      state.data.uploadSignature = data;
      state.data.cropSignature = data;
      state.data.useProfileSign = false;
      state.data.signatureLink = "";

    }

    // function uploadSignatureFile(event: any) {
    //   state.data.showSignatureUpload = true;
    //   state.data.uploadSignatureFile = event.target.files || event.dataTransfer.files;
    // }

    function uploadSignatureFile(event: any) {
      const files = event.target.files || event.dataTransfer.files;
      if (files && files.length > 0) {
        state.data.uploadSignatureFile = files;
        state.data.showSignatureUpload = true;
        nextTick(() => {
          if (signatureInput.value) {
            signatureInput.value.value = '';
          }
        });
      }
    }

    function setLocalStorageCompanyProfile() {
      const userInfo: any = localStorage.getItem("current_user_info");
      userInfo.company = {
        acknowledgement: state.data.companyInfo.acknowledgement,
        // eslint-disable-next-line @typescript-eslint/camelcase
        company_address: state.data.companyInfo.company_address
          ? state.data.companyInfo.company_address
          : "",
        // eslint-disable-next-line @typescript-eslint/camelcase
        company_email: state.data.companyInfo.company_email,
        // eslint-disable-next-line @typescript-eslint/camelcase
        company_name: state.data.companyInfo.company_name,
        // eslint-disable-next-line @typescript-eslint/camelcase
        company_phone_number: state.data.companyInfo.company_phone_number,
        // eslint-disable-next-line @typescript-eslint/camelcase
        legal_statement: state.data.companyInfo.legal_statement,
        logo: state.data.companyInfo.logo,
      };
      localStorage.removeItem("current_user_info");
      // localStorage.setItem("current_user_info", userInfo);
      // console.log("current_user_info", localStorage.setItem("current_user_info", userInfo));
      // localStorage.setItem("current_user_info", res.data.data.full_name);
    }

    const totalSendSubItem = computed(() => {
      let subItemCount = 0;

      for (const mainItem of state.data.sendPhases) {
        subItemCount += mainItem.sub_items.length;
      }

      return subItemCount;
    });
    const hasValidIds = computed(() => {
      /* eslint-disable vue/no-side-effects-in-computed-properties */
      const allIds = state.data.createPhase.reduce((acc: any, phase: any) => {
        return acc.concat(
          phase.groupTasks.reduce((groupAcc: any, groupTask: any) => {
            return groupAcc.concat(
              groupTask.items.map((item: any) => item.id)
              // groupTask.estimation_items.map((item: any) => item.id)
            );
          }, [])
        );
      }, []);

      // Example condition: check if there are any ids
      const mainIds = state.data.sendPhases.flatMap((phase: any) => phase.sub_items.map((item: any) => item.id));
      console.log("CHECK THE IDS >>> ", mainIds)
      console.log("ALL SELECTED IDS >>> ", allIds)
      state.data.selectedItemList = allIds;
      return allIds.length >= mainIds.length; // You can modify the condition as needed
      // return false; // You can modify the condition as needed
    });
    const isMatchingItems = computed(() => {
      const allIds = state.data.sendPhases.flatMap((phase: any) => phase.sub_items.map((item: any) => item.id));
      const selectedItems = state.data.selectedItemList;

      // Check if every selectedItem is in allIds and the lengths match
      /* eslint-enable vue/no-side-effects-in-computed-properties */
      return selectedItems.every((id: any) => allIds.includes(id)) && selectedItems.length === allIds.length;
    });
    // const isMatchingItems = computed(() => {
    //   // Flatten all IDs from state.data.sendPhases using map and concat
    //   const allIds = state.data.sendPhases.reduce((acc: any[], phase: any) => {
    //     return acc.concat(phase.sub_items.map((item: any) => item.id));
    //   }, []);

    //   // Extract all IDs from state.data.createphase using map and concat
    //   const allCreatePhaseIds = state.data.createphase.reduce((acc: any[], phase: any) => {
    //     return acc.concat(
    //       phase.groupTasks.reduce((subAcc: any[], groupTask: any) => {
    //         return subAcc.concat(groupTask.items.map((item: any) => item.id));
    //       }, [])
    //     );
    //   }, []);

    //   // Filter to get unique IDs from allCreatePhaseIds
    //   const uniqueCreatePhaseIds = allCreatePhaseIds.filter((id: any, index: number, self: any[]) =>
    //     self.indexOf(id) === index
    //   );

    //   // Check if every uniqueCreatePhaseId is in allIds and the lengths match
    //   return (
    //     uniqueCreatePhaseIds.every((id: any) => allIds.includes(id)) &&
    //     uniqueCreatePhaseIds.length === allIds.length
    //   );
    // });



    const addPhaseStatus = computed(() => {
      let activeStatus = false;
      let subItemCount = 0;

      for (const mainItem of state.data.sendPhases) {
        subItemCount += mainItem.sub_items.length;
      }

      if (subItemCount > state.data.selectedItemList.length) {
        activeStatus = true;
      } else {
        activeStatus = false;
      }
      return activeStatus;
    });

    const totalSelectedSubItem = computed(() => {
      let subItemCount = 0;

      for (const mainItem of state.data.createPhase) {
        subItemCount += mainItem.tasks.length;
      }

      return subItemCount;
    });

    function getUnselectedIds(phases: any[], selectedItems: any[]): any[] {
      return phases.flatMap(phase => phase.sub_items.map((item: any) => item.id))
        .filter(id => !selectedItems.includes(id));
    }


    function readImage(file: any) {
      const data = {} as any;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
        const extensionLower = extension.toLowerCase();
        data.file = e.target.result;
        data.name = file.name.replaceAll(`.${extension}`, "");
        data.extension = extensionLower;
        state.data.projectEstimations.attachments.push(data);
        console.log("CHECK DATA FOR UPLOAD>>", data);
        // state.imageList.push(data);
      };
      reader.readAsDataURL(file);
    }
    const dropFiles = (event: any) => {
      const files = event.target.files || event.dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        readImage(file);
      }
    };
    function hideConfirmation() {
      state.data.showDeletePhaseConfirmation =
        !state.data.showDeletePhaseConfirmation;
    }

    function removeSelectedAttachment(phase: any, image: any) {
      state.data.createPhase.forEach((item: any) => {
        if (item.id === phase.id) {
          phase.attachments = phase.attachments.filter(
            (att: any) => att != image
          );
        }
      });
      state.data.projectEstimations.attachments =
        state.data.projectEstimations.attachments.filter(
          (e: any) => e != image
        );
    }
    function removeSelectedImage(image: any) {
      state.data.projectEstimations.attachments =
        state.data.projectEstimations.attachments.filter(
          (e: any) => e != image
        );
    }
    function redirectToProjectToDo() {
      if (router.query.contractId) {
        route.push({
          name: "smart-contract-list",
          params: { projectId: state.data.projectId },
        });
      } else {
        // route.push({
        //   name: "list-job-estimation",
        //   params: { projectId: state.data.projectId },
        // });
        emit('redirect-to-job-estimation-list');
      }
    }

    function redirectToSmartContractList() {
      // route.push({
      //   name: "smart-contract-list",
      //   params: { projectId: state.data.projectId },
      // });
      emit('back-to-smart-contract-list');
    }

    function closeSuccessCustomModal() {
      state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
      $("#successfulModal").modal("hide");
      redirectToSmartContractList();
    }

    function addCustomerEmail(data: any) {
      isInvalid.value = false;
      const email = data;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email == localStorage.getItem("current_user_email")) {
        isInvalid.value = true;
        return false;
      }
      if (!emailRegex.test(email)) {
        isInvalid.value = true;
        return false;
      }
      const addData = {
        email: data,
        // eslint-disable-next-line @typescript-eslint/camelcase
        first_name: "",
        // eslint-disable-next-line @typescript-eslint/camelcase
        middle_name: "",
        // eslint-disable-next-line @typescript-eslint/camelcase
        last_name: "",
        // eslint-disable-next-line @typescript-eslint/camelcase
        address_line1: "",
        code: data,
        phone: "",
        isEdit: true,
        emailError: "",
        phoneError: "",
        lastNameError:"",
        firstNameError:"",
        mailNotification:true,
        smsNotification:false,
        isPhoneFromApi:false,
        isMailFromApi:true
      };
      state.data.allCustomer.push(addData);
      state.data.selectedCustomers.push(addData);
      //  state.data.allCustomer.push(data);
    }

    function showDelete(data: any) {
      state.data.removeUser = data;
      $("#deleteModal").modal("show");
    }

    function hideDelete() {
      $("#deleteModal").modal("hide");
    }

    function isEmailValid(item: any) {
      const email = item.email;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email == localStorage.getItem("current_user_email")) {
        item.emailError = "Owner email  not valid here.";
        return false;
      }
      if (!emailRegex.test(email)) {
        item.emailError = "Please enter valid email.";
        return false;
      }
      item.emailError = "";
      return true;
    }

    function isPhoneValid(item: any) {
      const phone = item.phone;
      const phoneRegex = /^1?\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;
      if (!phoneRegex.test(phone)) {
        item.phoneError = "Please enter valid phone.";
        return false;
      }
      item.phoneError = "";
      return true;
    }

    function isFirstNameEmpty(item: any) {
      if (!item.first_name || item.first_name.trim() === "") {
        item.firstNameError = "First name is required.";
        return true;
      }
      item.firstNameError = "";
      return false;
    }

    function isLastNameEmpty(item: any) {
      if (!item.last_name || item.last_name.trim() === "") {
        item.lastNameError = "Last name is required.";
        return true;
      }
      item.lastNameError = "";
      return false;
    }

    function editSelectCustomer(data: any) {
      state.data.selectedCustomers[data].isEdit = true;
    }
    function updateSelectCustomer(data: any) {
      const item = state.data.selectedCustomers[data];
      item.emailError = "";
      item.phoneError = "";
      item.firstNameError = "";
      item.lastNameError = "";

      // Validate first name and last name
      const firstNameEmpty = isFirstNameEmpty(item);
      const lastNameEmpty = isLastNameEmpty(item);

      if (firstNameEmpty || lastNameEmpty) {
        return;
      }

      if (item.phone) {
        if (isEmailValid(item)) {
          item.emailError = "";
          item.phoneError = "";
        }
        if (isPhoneValid(item)) {
          item.emailError = "";
          item.phoneError = "";
          item.isEdit = false;
        }
      } else {
        if (isEmailValid(item)) {
          item.emailError = "";
          item.phoneError = "";
          item.isEdit = false;
        }
      }
    }

    function removeSelectCustomer(data: any) {
      state.data.selectedCustomers = state.data.selectedCustomers.filter(
        (e: any) => e != data
      );
      hideDelete();
    }

    function changeValue() {
      isInvalid.value = false;
    }

    function removeUploadSelectedImage(image: any) {
      state.ui.errors.hasError = false;
      if (state.ui.isPostLoading.removeSelectedImage) return false;
      state.ui.isPostLoading.removeSelectedImage = true;
      ethitransService
        .projectDocumentDelete(image.uuid.toString())
        .then((res: any) => {
          state.data.projectEstimations.attachments =
            state.data.projectEstimations.attachments.filter(
              (e: any) => e != image
            );
        })
        .catch((error: any) => {
          common
            .sdCatchErr(error, state.ui.errors.errorList.approval)
            .then((res: any) => {
              state.ui.errors.hasError = true;
              for (const [key, value] of Object.entries(res)) {
                if (Array.isArray(value)) {
                  state.ui.errors.errorList.approval.push(value[0]);
                }
              }
            });
        })
        .finally(() => {
          state.ui.isPostLoading.removeSelectedImage = false;
        });
    }

    function validateSendInvitation() {
      state.ui.errors.hasError = false;
      if (
        !state.data.uploadSignature && !state.data.signatureLink && !state.data.sendarSignature
      ) {
        state.ui.errors.errorList.approval.push(t('use_upload_draw_your_valid_signature'));
        state.ui.isPostLoading.checkSignature = true;
      }
      if (state.data.selectedCustomers.length == 0) {
        state.ui.errors.errorList.approval.push(t('one_customer_is_required'));
      }
      if (!state.projectDate.type) {
        state.ui.errors.errorList.approval.push('Project Timeline is required');
      }



      state.data.selectedCustomers.forEach((user: any) => {
        if (!user.first_name || !user.last_name) {
          state.ui.errors.errorList.approval.push(t('First and Last name required for each customer'));
        }
      });

      // // If type is not Custom Date, ensure a number is provided
      // if (['1', '2', '3'].includes(state.projectDate.type) && !state.projectDate.value) {
      //   state.ui.errors.errorList.approval.push(t('project_date_number_is_required'));
      // }

      // if (!state.projectDate.type) {
      //   state.ui.errors.errorList.approval.push(t('project_date_type_is_required'));
      // }

      // // If type is not Custom Date, ensure a number is provided
      // if (['1', '2', '3',].includes(state.projectDate.type) && !state.projectDate.value) {
      //   state.ui.errors.errorList.approval.push(t('project_date_number_is_required'));
      // }

      // Validate custom start and end date for Custom Date type
      if (state.projectDate.type === '5') {
        if (!state.projectDate.startDate || !state.projectDate.endDate) {
          state.ui.errors.errorList.approval.push(t('Custom dates are required'));
        } else if (new Date(state.projectDate.startDate) >= new Date(state.projectDate.endDate)) {
          state.ui.errors.errorList.approval.push(t('custom_dates_invalid_range'));
        }
      }
      // if (!state.data.projectEstimations.startDate) {
      //   state.ui.errors.errorList.approval.push(t('start_date_is_required'));
      // }
      if (
        !state.data.projectEstimations.estimatedBudget ||
        parseInt(state.data.projectEstimations.estimatedBudget) <= 0
      ) {
        state.ui.errors.errorList.approval.push(t('budget_is_required'));
      }
      // if (!state.data.projectEstimations.endDate) {
      //   state.ui.errors.errorList.approval.push(t('end_date_is_required'));
      // }
      // if (
      //   state.data.projectEstimations.startDate &&
      //   state.data.projectEstimations.endDate
      // ) {
      //   const d1 = new Date(state.data.projectEstimations.startDate).getTime();
      //   const d2 = new Date(state.data.projectEstimations.endDate).getTime();
      //   if (d2 < d1) {
      //     state.ui.errors.errorList.approval.push(
      //       t('date_is_not_in_valid_range')
      //     );
      //   }
      // }
      const unselectedIds = getUnselectedIds(state.data.sendPhases, state.data.selectedItemList);

      if (state.data.createPhase.length === 0) {
        state.ui.errors.errorList.approval.push(t('at_least_one_phase_is_required'));
      } else if (unselectedIds.length > 0) {
        const itemWord = unselectedIds.length === 1 ? 'item' : 'items';
        const message = `${unselectedIds.length} ${itemWord} ${t('remaining_to_select')}`;
        state.ui.errors.errorList.approval.push(message);
      }

      if (
        !state.ui.errors.errorList.approval &&
        !state.ui.errors.errorList.approval.length
      ) {
        state.ui.errors.hasError = false;
      } else if (state.ui.errors.errorList.approval.length != 0) {
        state.ui.errors.hasError = true;
      }
    }
    const iActiveValidation = computed(() => {
      const phases: boolean = state.data.createPhase.length === 0;
      const isPostLoading: boolean = state.ui.isPostLoading.sendEstimation;

      // Your logic based on phases and isPostLoading
      if (phases && isPostLoading) {
        // Return value when both conditions are true
        return true;
      } else {
        // Return value when both conditions are false
        return false;
      }
    });

    function sendInvitationEstimation(data: any) {
      // console.log("im", state.data.createPhase);
      state.ui.isPostLoading.saveEstimation = false;
      state.ui.isPostLoading.sendEstimation = false;

      state.ui.isLoading.isReadyToSend = false;
      // if (!signaturePad.isEmpty() && signaturePad.toData()) {
      //   state.data.uploadSignature = signaturePad.toDataURL();
      // } else {
      //   state.data.uploadSignature = "";
      //   state.data.sendarSignatureFileLink = state.data.sendarSignature;
      // }
      const selectPhases = [] as any;

      state.data.sendPhases.forEach((phase: any) => {
        phase.sub_items.forEach((item: any) => {
          if (item.isChecked == true) {
            selectPhases.push(item.id);
          }
        });
      });

      state.ui.errors.errorList.approval = [];
      // const mainIds = state.data.sendPhases.flatMap((phase: any) => phase.sub_items.map((item: any) => item.id));
      // console.log("CHECK THE IDS >>> ", mainIds)
      // console.log("CHECK ALL SELECTED >>> ", state.data.selectedItemList)
      // console.log("HERE >>> ", hasValidIds.value)
      // if (hasValidIds.value === false) {
      //   state.ui.errors.errorList.approval.push("One Phase is required.");
      // }

      validateSendInvitation();

      if (
        state.ui.isPostLoading.saveEstimation ||
        state.ui.errors.errorList.approval.length != 0 ||
        state.ui.errors.hasError
      )
        return false;
      if (
        state.ui.isPostLoading.sendEstimation ||
        state.ui.errors.errorList.approval.length != 0 ||
        state.ui.errors.hasError
      )
        return false;
      // if (totalSendSubItem.value > totalSelectedSubItem.value) {
      //   state.ui.isLoading.isReadyToSend = true;
      //   return false;
      // }

      if (router.query.contractId) {
        console.log("contract::", state.data.createPhase);
        state.data.createPhase.forEach((phase: any) => {
          // eslint-disable-next-line @typescript-eslint/camelcase
          phase.start_date = phase.startDate ? phase.startDate : "";
          // eslint-disable-next-line @typescript-eslint/camelcase
          phase.end_date = phase.endDate ? phase.startDate : "";
          phase.files = phase.attachments ? phase.attachments : [];
          phase.groupTasks = [];
          phase.groupTasks = phase.child_phases;
          console.log('44', phase.groupTasks)
          phase.groupTasks.forEach((task: any) => {
            task.items = [];
            // eslint-disable-next-line @typescript-eslint/camelcase
            task.start_date = task.startDate ? phase.startDate : "";
            // eslint-disable-next-line @typescript-eslint/camelcase
            task.end_date = task.endDate ? phase.startDate : "";
            // eslint-disable-next-line @typescript-eslint/camelcase
            task.estimation_items = task.items.map((item: any) => item.id);
            // task.estimation_items = task.estimation_items.map((item: any) => item.id);
            task.budget = task.budget ? task.budget : task.cost;
            // task.items = task.items;
          });

        });
      } else {
        state.data.createPhase.forEach((phase: any) => {
          // eslint-disable-next-line @typescript-eslint/camelcase
          phase.start_date = phase.startDate ? phase.startDate : "";
          // eslint-disable-next-line @typescript-eslint/camelcase
          phase.end_date = phase.endDate ? phase.startDate : "";
          phase.files = phase.attachments ? phase.attachments : [];
          phase.groupTasks.forEach((task: any) => {
            // eslint-disable-next-line @typescript-eslint/camelcase
            task.start_date = task.startDate ? phase.startDate : "";
            // eslint-disable-next-line @typescript-eslint/camelcase
            task.end_date = task.endDate ? phase.startDate : "";
            // eslint-disable-next-line @typescript-eslint/camelcase
            task.estimation_items = task.estimation_items ? task.estimation_items.map((item: any) => item.id) : task.items ? task.items.map((item: any) => item.id) : [];
            task.budget = task.budget ? task.budget : task.cost;
          });
        });
      }

      if (data === 0) {
        state.ui.isPostLoading.saveEstimation = true;
      } else {
        state.ui.isPostLoading.sendEstimation = true;
      }

      console.log('customer data', state.data.selectedCustomers);

      const payLoad = {
        status: data,
        // eslint-disable-next-line @typescript-eslint/camelcase
        estimation_id: state.data.estimationId,
        payers: state.data.selectedCustomers,
        phases: state.data.createPhase,
        logo: state.data.estimation.logo ? state.data.estimation.logo : state.data.companyInfo.logo,
        acknowledgement: acknowledgement.value,
        // eslint-disable-next-line @typescript-eslint/camelcase
        legal_statement: legalStatement.value,
        budget: state.data.projectEstimations.estimatedBudget,
        files: state.data.projectEstimations.attachments,
        // eslint-disable-next-line @typescript-eslint/camelcase
        edoc_id: state.data.projectEstimations.edocLink,
        // eslint-disable-next-line @typescript-eslint/camelcase
        approve_by_all: state.data.approveByAll,
        signature: state.data.uploadSignature,
        // eslint-disable-next-line @typescript-eslint/camelcase
        signature_link: state.data.sendarSignature ? state.data.sendarSignature : state.data.signatureLink,
        // eslint-disable-next-line @typescript-eslint/camelcase
        phaseTimeline: (state.data.createPhase as Array<{ phaseTimeline: any }>).map((phase) => ({
          // eslint-disable-next-line @typescript-eslint/camelcase
          type: phase.phaseTimeline.type,
          // eslint-disable-next-line @typescript-eslint/camelcase
          value: phase.phaseTimeline.value,
          // eslint-disable-next-line @typescript-eslint/camelcase
          startDate: phase.phaseTimeline.startDate,
          // eslint-disable-next-line @typescript-eslint/camelcase
          endDate: phase.phaseTimeline.endDate,
        })),
        // eslint-disable-next-line @typescript-eslint/camelcase
        projectTimeline: {
          type: state.projectDate.type,
          value: state.projectDate.value,
          // eslint-disable-next-line @typescript-eslint/camelcase
          startDate: state.projectDate.startDate,
          // eslint-disable-next-line @typescript-eslint/camelcase
          endDate: state.projectDate.endDate,
        },

      };
      console.log("PAYLOAD >>> ", payLoad)
      state.ui.isLoading.loadDetailsData = true;

      ethitransService
        .estimationSend(payLoad)
        .then((res: any) => {
          if (data === 0) {
            state.data.successFulMessage = t('smart_contract_saved_successfully');
          } else {
            state.data.successFulMessage = t('smart_contract_sent_successfully');
          }
          state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
        })
        .catch((error: any) => {
          // console.log(error);
          common
            .sdCatchErr(error, state.ui.errors.errorList.approval)
            .then((res: any) => {
              state.ui.errors.hasError = true;
              for (const [key, value] of Object.entries(res)) {
                if (Array.isArray(value)) {
                  state.ui.errors.errorList.approval.push(value[0]);
                }
              }
            });
        })
        .finally(() => {
          state.ui.isLoading.loadDetailsData = false;
          if (data === 0) {
            state.ui.isPostLoading.saveEstimation = true;
          } else {
            state.ui.isPostLoading.sendEstimation = true;
          }
          state.data.uploadSignature = "";
        });
    }

    function showUploadImageModel() {
      $("#updateUpload").modal("show");
    }

    function hideShowUploadImageModel() {
      $("#profileUpdate").val("");
      $("#updateUpload").modal("hide");
    }

    function readSignature(file: any) {
      const data = {} as any;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
        const extensionLower = extension.toLowerCase();
        data.base64 = e.target.result;
        data.duplicateFile = false; // data.fileName = file.name;
        data.fileName = file.name.replaceAll(`.${extension}`, "");
        data.extension = extensionLower;
        data.isuploded = false;
        data.tag = [] as any;
        data.size = common.formatBytes(parseInt(file.size));
        // state.data.uploadImageData = data;
        state.data.newUploadImge = data.base64;
        state.data.cropImage = data.base64;
        state.data.signatureFileName = data.fileName;
      };
      reader.readAsDataURL(file);
    }

    function readLogo(file: any) {
      const data = {} as any;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
        const extensionLower = extension.toLowerCase();
        data.file = e.target.result;
        data.filename = file.name.replaceAll(`.${extension}`, "");
        data.extension = extensionLower;
        data.isuploded = false;
        data.size = common.formatBytes(parseInt(file.size));
        state.data.estimation.logo = data.file;
        console.log('READ LOGO DATA Check>>>', state.data.estimation.logo)
      };
      reader.readAsDataURL(file);
    }

    function onDocumentChange(event: any) {
      const files = event.target.files || event.dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        // console.log("FILE CHECK >>>", file);
        // if(file.type)
        const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
        const extensionLower = extension.toLowerCase();
        readSignature(file);
        $("#updateUpload").modal("show");
      }
    }

    function uploadLogo(event: any) {
      const files = event.target.files || event.dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        // console.log("FILE CHECK >>>", file);
        // if(file.type)
        const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
        const extensionLower = extension.toLowerCase();
        readLogo(file);
      }
    }

    function saveSignature() {
      hideShowUploadImageModel();
    }

    function clearSignature() {
      state.data.cropSignature = "";
    }



    function enableSignaturPad() {
      state.ui.isLoading.signaturePadLoad =
        !state.ui.isLoading.signaturePadLoad;

    }
    // state.data.sendPhases
    function getJobEstimationDetails() {
      state.ui.isLoading.loadDetailsData = true;
      ethitransService
        .getJobEstimationDetails(state.data.estimationId)
        .then((res: any) => {
          console.log('The job estimation details is:', res.data.data)
          state.data.projectEstimations.name = res.data.data.project.name;
          state.data.projectId = res.data.data.project.uuid;
          state.data.projectEstimations.description =
            res.data.data.project.description;
          state.data.projectEstimations.estimatedBudget =
            res.data.data.total_amount;
          state.data.sendarSignature = res.data.data.estimation.signature;
          state.data.estimation = res.data.data.estimation;

          if (router.query.contractId && props.estimationId) {
            res.data.data.phases.forEach((phase: any) => {
              phase.isChecked = true;
              phase.isDisabled = true;
              phase.budget = phase.estimation_amount;
              // phase.startDate = common.localDateOnly(phase.start_date);
              // phase.endDate = common.localDateOnly(phase.end_date);
              phase.sub_items.forEach((child: any) => {
                child.isChecked = true;
                child.isDisabled = true;
                // child.isChecked = true;
                child.budget = child.cost;
                // child.startDate = common.localDateOnly(child.start_date);
                // child.endDate = common.localDateOnly(child.end_date);
                // state.data.sendPhases.push(child);
              });
            });

            // res.data.data.phases.forEach((phase: any) => {
            //   phase.isChecked = false;
            //   phase.isDisabled = false;
            //   phase.budget = phase.estimation_amount;
            //   // phase.startDate = common.localDateOnly(phase.start_date);
            //   // phase.endDate = common.localDateOnly(phase.end_date);
            //   phase.sub_items.forEach((child: any) => {
            //     child.isChecked = false;
            //   child.isDisabled = false;
            //     // child.isChecked = true;
            //     child.budget = child.cost
            //     // child.startDate = common.localDateOnly(child.start_date);
            //     // child.endDate = common.localDateOnly(child.end_date);
            //     // state.data.sendPhases.push(child);
            //   });
            // });
          } else if (props.estimationId) {
            res.data.data.phases.forEach((phase: any) => {
              phase.isChecked = false;
              phase.isDisabled = false;
              phase.budget = phase.estimation_amount;
              // phase.startDate = common.localDateOnly(phase.start_date);
              // phase.endDate = common.localDateOnly(phase.end_date);
              phase.sub_items.forEach((child: any) => {
                child.isChecked = false;
                child.isDisabled = false;
                // child.isChecked = true;
                child.budget = child.cost;
                // child.startDate = common.localDateOnly(child.start_date);
                // child.endDate = common.localDateOnly(child.end_date);
                // state.data.sendPhases.push(child);
              });
            });
          }
          // console.log("After here", res.data.data.phases);
          state.data.sendPhases = res.data.data.phases;
          console.log("RESULT here", state.data.sendPhases);
          res.data.data.payers.forEach((user: any) => {
            const data = {
              email: user.email,
              // eslint-disable-next-line @typescript-eslint/camelcase
              first_name: user.first_name,
              // eslint-disable-next-line @typescript-eslint/camelcase
              middle_name: user.middle_name,
              // eslint-disable-next-line @typescript-eslint/camelcase
              last_name: user.last_name,
              // eslint-disable-next-line @typescript-eslint/camelcase
              address_line1: user.address_line1,
              mailNotification: false,
              smsNotification: false,
              code: user.email,
              // eslint-disable-next-line @typescript-eslint/camelcase
              phone: user.phone,
              isEdit: false,
            };
            if (data.email) {
              data.mailNotification = true;
            }
            state.data.allCustomer.push(data);
          });
          res.data.data.payers.forEach((user: any) => {
            const data = {
              email: user.email,
              // eslint-disable-next-line @typescript-eslint/camelcase
              first_name: user.first_name,
              // eslint-disable-next-line @typescript-eslint/camelcase
              middle_name: user.middle_name,
              // eslint-disable-next-line @typescript-eslint/camelcase
              last_name: user.last_name,
              // eslint-disable-next-line @typescript-eslint/camelcase
              address_line1: user.address_line1,
              code: user.email || user.contact_number,
              // eslint-disable-next-line @typescript-eslint/camelcase
              phone: user.contact_number,
              mailNotification: false,
              smsNotification: false,
              isEdit: false,
              emailError: "",
              phoneError: "",
              isPhoneFromApi: false,
              isMailFromApi:false
            };
            if (data.email) {
              data.mailNotification = true;
              data.isMailFromApi = true
            }
            if(data.phone){
              data.smsNotification = true
              data.isPhoneFromApi = true
            }
            state.data.selectedCustomers.push(data);
          });
        })
        .catch((error: any) => {
          console.log(error);
        })
        .finally(() => {
          state.ui.isLoading.loadDetailsData = false;
        });
    }

    function showAddPhaseModal() {
      state.ui.errors.errorList.approval = [];
      state.ui.isLoading.projectDate = false;
      state.ui.isLoading.projectDate = false;
      state.ui.errors.hasError = false;
      if (!state.projectDate) {
        state.ui.isLoading.projectStartDate = true;
        state.ui.errors.hasError = true;
        state.ui.errors.errorList.approval.push(t('start_date_is_required'));
      }
      if (!state.projectDate) {
        state.ui.isLoading.projectDate = true;
        state.ui.errors.hasError = true;
        state.ui.errors.errorList.approval.push(t('end_date_is_required'));
      }
      if (
        state.projectDate
      ) {
        state.data.showAddPhaseModal = !state.data.showAddPhaseModal;
      }
    }
    function resetAddPhaseModal() {
      state.data.createPhase[state.data.selectedIndex] = state.data.editData;
    }

    function closeAddPhaseModal() {
      state.data.editMode = false;
      state.data.selectedIndex = "";

      state.data.selectedTaskIndex = "";
      state.data.showAddPhaseModal = !state.data.showAddPhaseModal;
    }

    function addNewPhase(data: any) {
      console.log(" Hello addNewPhase", data);

      state.data.editData = {};
      data.startDate = common.localDateOnly(data.startDate);
      data.endDate = common.localDateOnly(data.endDate);
      state.data.createPhase.push(data);
      console.log("CHECK THE CREATE PHASE >>> ", state.data.createPhase);
      // console.log("ADD Beofre >>", state.data.sendPhases);
      state.data.sendPhases.forEach((item: any) => {
        state.data.createPhase.forEach((phase: any) => {
          phase.tasks.forEach((task: any) => {
            console.log("<<>>");

            if (task.mainName === item.name) {
              // console.log("ADD MODIFIED");
              item.isDisabled = true;
              item.isChecked = true;
              item.sub_items.forEach((sub: any) => {
                sub.isDisabled = true;
                sub.isChecked = true;
              });
            }
          });
        });
      });
      console.log("After >>", state.data.sendPhases);
    }

    function editNewPhase(data: any, index: any) {
      // state.data.createPhase
      console.log("Check editNewPhase data >>>", data);
      console.log("Check >>>", data.tasks);
      state.data.editMode = true;
      state.data.selectedIndex = index;
      state.data.editFrom = "phase";
      state.data.editData = data;
      showAddPhaseModal();
    }

    function editTask(data: any, phaseIndex: any, taskIndex: any) {
      state.data.editMode = true;
      state.data.editFrom = "task";
      state.data.selectedIndex = phaseIndex;
      state.data.selectedTaskIndex = taskIndex;
      state.data.editData = data;
      showAddPhaseModal();
    }

    function resetChecked(data: any) {
      console.log("RESET >>> ", data)
      state.data.sendPhases = data;
    }
    function updatePhase(data: any) {
      console.log("UPDATE CGECJ >>> ", data)
      state.data.createPhase[state.data.selectedIndex] = data;
      console.log("After >>", state.data.sendPhases);
    }

    function updateTask(data: any) {
      data.startDate = common.localDateOnly(data.startDate);
      data.endDate = common.localDateOnly(data.endDate);
      state.data.createPhase[state.data.selectedIndex].tasks[
        state.data.selectedTaskIndex
      ] = data;
    }
    function selectForDeletePhase(item: any) {
      console.log("item delete", item);
      let deleteId = [] as any;
      if (item.estimation_items && item.estimation_items.length) {
        deleteId = item.groupTasks.flatMap((gTask: any) =>
          gTask.estimation_items.map((item: any) => item.id)
        );

      } else {
        deleteId = item.groupTasks.flatMap((gTask: any) =>
          gTask.items.map((item: any) => item.id)
        );

      }
      state.data.selectedItemList = state.data.selectedItemList.filter(
        (item: any) => !deleteId.includes(item)
      );
      console.log("item delete", state.data.selectedItemList);

      state.data.selectedforDelete = item;
      state.data.showDeletePhaseConfirmation =
        !state.data.showDeletePhaseConfirmation;
    }

    function removeSelectedPhase() {
      // reset of main Item
      // state.data.sendPhases
      const item = state.data.selectedforDelete
        ? state.data.selectedforDelete
        : ([] as any);
      state.data.sendPhases.forEach((mainItem: any) => {
        mainItem.sub_items.forEach((subItem: any) => {
          item.tasks.forEach((selectedPhase: any) => {
            if (
              selectedPhase.main_item_id == subItem.main_item_id &&
              !subItem.item.parent_id
            ) {
              console.log("MATCHED");

              mainItem.isChecked = false;
              mainItem.isDisabled = false;
            }
            // for SubItem Checked
            if (subItem.main_item_id === selectedPhase.main_item_id) {
              subItem.isChecked = false;
              subItem.isDisabled = false;
            }
          });
        });
      });
      state.data.createPhase = state.data.createPhase.filter(
        (e: any) => e != item
      );
    }

    function removeTask(phaseIndex: any, taskIndex: any) {
      state.data.createPhase[phaseIndex].tasks.splice(taskIndex, 1);
    }

    function showCreateCompanyModel() {
      $("#addCompanyInfo").modal("show");
    }

    function hideCreateCompanyModel() {
      state.ui.errors.errorList.createCompanyIfno = [];
      $("#addCompanyInfo").modal("hide");
      state.ui.isLoading.isCompanyEdit = false;
    }
    function editCompany() {
      state.ui.isLoading.isCompanyEdit = !state.ui.isLoading.isCompanyEdit;
      $("#addCompanyInfo").modal("show");
    }
    function validateCreateCompany() {
      // console.log("*** TODO VALIDATION  ***");
      state.ui.errors.hasError = false;
      state.ui.errors.errorList.createCompanyIfno = [];
      if (
        !state.data.companyInfo.company_name &&
        !state.ui.isLoading.isCompanyEdit
      ) {
        state.ui.errors.errorList.createCompanyIfno.push(
          "Company name is required."
        );
      }
      if (
        !state.data.companyInfo.company_email &&
        !state.ui.isLoading.isCompanyEdit
      ) {
        state.ui.errors.errorList.createCompanyIfno.push(
          "Company Email is required."
        );
      }
      if (!state.data.companyInfo.logo) {
        state.ui.errors.errorList.createCompanyIfno.push(
          "Company logo is required."
        );
      }
      if (!state.data.companyInfo.acknowledgement) {
        state.ui.errors.errorList.createCompanyIfno.push(
          "Company acknowledgement is required."
        );
      }
      // eslint-disable-next-line @typescript-eslint/camelcase
      if (!state.data.companyInfo.legal_statement) {
        state.ui.errors.errorList.createCompanyIfno.push(
          "Company legal statement is required."
        );
      }
      if (
        !state.ui.errors.errorList.createCompanyIfno &&
        !state.ui.errors.errorList.createCompanyIfno.length
      ) {
        state.ui.errors.hasError = false;
      } else if (state.ui.errors.errorList.createCompanyIfno.length != 0) {
        state.ui.errors.hasError = true;
      }
    }
    //no profile set
    function createCompanyIfno() {
      state.ui.errors.errorList.createCompanyIfno = [];
      state.ui.errors.hasError = false;

      validateCreateCompany();

      if (state.ui.isPostLoading.createCompanyIfno) return false;
      if (
        state.ui.errors.hasError ||
        state.ui.errors.errorList.createCompanyIfno.length != 0
      )
        return false;

      if (state.ui.isLoading.isCompanyEdit) {
        hideCreateCompanyModel();
      }
      const payLoad: any = {
        // eslint-disable-next-line @typescript-eslint/camelcase
        company_name: state.data.companyInfo.company_name,
        // eslint-disable-next-line @typescript-eslint/camelcase
        logo: state.data.companyInfo.logo,
        // eslint-disable-next-line @typescript-eslint/camelcase
        company_phone_number: state.data.companyInfo.company_phone_number,
        // eslint-disable-next-line @typescript-eslint/camelcase
        company_email: state.data.companyInfo.company_email,
        // eslint-disable-next-line @typescript-eslint/camelcase
        acknowledgement: state.data.companyInfo.acknowledgement,
        // eslint-disable-next-line @typescript-eslint/camelcase
        legal_statement: state.data.companyInfo.legal_statement,
      };
      state.ui.isPostLoading.createCompanyIfno = true;
      ethitransService
        .updateCompanyInfo(payLoad)
        .then((res: any) => {
          hideCreateCompanyModel();
        })
        .catch((error: any) => {
          console.log(error);
          common
            .sdCatchErr(error, state.ui.errors.errorList.createCompanyIfno)
            .then((res: any) => {
              state.ui.errors.hasError = true;
              for (const [key, value] of Object.entries(res)) {
                if (Array.isArray(value)) {
                  state.ui.errors.errorList.createCompanyIfno.push(value[0]);
                }
              }
            });
        })
        .finally(() => {
          state.ui.isPostLoading.createCompanyIfno = false;
        });
    }

    function usdPriceFormate(data: any, type: any) {
      if (data != null) {
        if (type == 1) {
          return data.toLocaleString('en-US', {
            minimumFractionDigits: 2,
          }) + '%';
        } else {
          return data.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
          });
        }

      }
    }

    onBeforeRouteLeave((to, from) => {
      closeAddPhaseModal();
      state.data.showAddPhaseModal = false;
      $("#successfulModal").modal("hide");
      state.data.showDeletePhaseConfirmation = false;
      hideDelete();
      hideShowUploadImageModel();
      hideCreateCompanyModel();
    });

    function userSignature(from: any) {
      ethitransService
        .userSignature()
        .then((res: any) => {
          if (from == 'onMount' && res.data.data.signature) {
            state.data.haveProfileSign = true;
          }
          if (from == 'use' && res.data.data.signature) {
            state.data.useProfileSign = true;
            state.data.uploadSignature = "";
            state.data.sendarSignature = "";
            state.data.cropSignature = res.data.data.signature;
            state.data.signatureLink = res.data.data.signature;
          }
        })
        .catch((error: any) => {
          //   common
        })
        .finally(() => {
          //   state.ui.isLoading.userStatus = true;
        });
    }


    function calculateTaskDays(timeline: any) {
      console.log('Received timeline:', timeline);

      if (!timeline || timeline.value == null || timeline.type == null) {
        console.log('Invalid timeline input. Returning 0 days.');
        return '0 days';
      }

      let days = 0;
      let isTBD = false;

      switch (timeline.type) {
        case '1': // days
          days = Number(timeline.value);
          console.log('Type is days. Days set to:', days);
          break;
        case '2': // weeks
          days = Number(timeline.value) * 7;
          console.log('Type is weeks. Days calculated as:', days);
          break;
        case '3': // months
          days = Number(timeline.value) * 30;
          console.log('Type is months. Days calculated as:', days);
          break;
        case '4': // TBD
          isTBD = true;
          break;
        default:
          console.log('Unknown type:', timeline.type);
      }

      if (timeline.excludeWeekends === 1 && days > 0) {
        const fullWeeks = Math.floor(days / 7);
        const excludedWeekends = fullWeeks * 2;
        console.log('Excluding weekends:', excludedWeekends, 'from', days);
        days -= excludedWeekends;
        console.log('Days after excluding weekends:', days);
      }

      const result = (days === 0 && isTBD) ? 'TBD' : isTBD ? `${days} + TBD days` : `${days} days`;
      console.log('Final result:', result);
      return result;
    }
    function calculatePhaseTotalDays(phase: any) {
      // Your previously provided function logic here
      let totalDays = 0;
      let hasTBD = false;

      phase.groupTasks.forEach((task: any) => {
        const timeline = task.taskTimeline;

        if (!timeline || timeline.value == null || timeline.type == null) return;

        let days = 0;

        switch (timeline.type.toString()) {
          case '1': // Days
            days = Number(timeline.value);
            break;
          case '2': // Weeks
            days = Number(timeline.value) * 7;
            break;
          case '3': // Months
            days = Number(timeline.value) * 30;
            break;
          case '4': // TBD
            hasTBD = true;
            break;
          default:
            break;
        }

        if (timeline.excludeWeekends === 1 && days > 0) {
          const fullWeeks = Math.floor(days / 7);
          const excludedWeekends = fullWeeks * 2;
          days -= excludedWeekends;
        }

        totalDays += days;
      });

      return hasTBD
        ? totalDays === 0 ? 'TBD' : `${totalDays} + TBD days`
        : `${totalDays} days`;
    }

    const calculateProjectTotalDays = computed(() => {
      let projectTotalDays = 0;
      let hasTBD = false; // Flag to track if "TBD" is present

      console.log('Calculating project total days...'); // Log when project total days calculation starts

      // Loop through each phase and sum up the total days
      state.data.createPhase.forEach((phase: any) => {
        const phaseTotalDays = calculatePhaseTotalDays(phase);

        console.log('Phase Total Days:', phaseTotalDays); // Log each phase's total days


        if (phaseTotalDays.includes('TBD')) {
          hasTBD = true;
        }

        const numericDays = parseInt(phaseTotalDays);
        if (!isNaN(numericDays)) {
          projectTotalDays += numericDays;
        }
      });

      // Log the final result
      console.log('Total project days (before TBD check):', projectTotalDays);

      // Return the project total days with "TBD" if any phase is TBD
      let result = '';
      if (projectTotalDays === 0 && hasTBD) {
        result = 'TBD';
      } else if (hasTBD) {
        result = `${projectTotalDays} + TBD days`;
      } else {
        result = `${projectTotalDays} days`;
      }
      console.log('Final project total days:', result); // Log the final calculated project total days

      return result;
    });



    onMounted(() => {
      const userData: any = localStorage.getItem("current_user_info");
      const company: any = JSON.parse(userData).company
        ? JSON.parse(userData).company
        : "";
      state.data.companyInfo.logo = company.logo;
      // eslint-disable-next-line @typescript-eslint/camelcase
      state.data.companyInfo.company_name = company.company_name;
      // eslint-disable-next-line @typescript-eslint/camelcase
      state.data.companyInfo.company_phone_number = company.company_phone_number;
      // eslint-disable-next-line @typescript-eslint/camelcase
      state.data.companyInfo.company_email = company.company_email;
      state.data.companyInfo.acknowledgement = company.acknowledgement;
      // eslint-disable-next-line @typescript-eslint/camelcase
      state.data.companyInfo.legal_statement = company.legal_statement;
      // if (router.query.contractId) {
      //   getSmartContractDetails();
      // }
      state.data.estimationId = props.estimationId;
      console.log('The Estimation ID on ProjectWokflowEstimation is:', state.data.estimationId)
      getJobEstimationDetails();
      totalSendSubItem;
      totalSelectedSubItem;
      userSignature('onMount');

    });
    function filterUsersWithEmail(users: Array<{ email: string }>) {
      return users.filter(user => user.email.trim() !== '');
    }
    return {
      state,
      resetAddPhaseModal,
      numberLabel,
      handleDateTypeChange,
      customStartDate,
      customEndDate,
      hideCustomValidity,
      saveCustomDaysToselectedMember,
      calculateTaskDays,
      calculatePhaseTotalDays,
      calculateProjectTotalDays,
      hasValidIds,
      isMatchingItems,
      iActiveValidation,
      setLocalStorageCompanyProfile,
      removeSelectedAttachment,
      selectForDeletePhase,
      hideConfirmation,
      addPhaseStatus,
      removeSelectedImage,
      dropFiles,
      addCustomerEmail,
      removeSelectCustomer,
      editSelectCustomer,
      updateSelectCustomer,
      closeSuccessCustomModal,
      showDelete,
      hideDelete,
      isEmailValid,
      isPhoneValid,
      isInvalid,
      changeValue,
      removeUploadSelectedImage,
      sendInvitationEstimation,
      validateSendInvitation,
      redirectToProjectToDo,
      canvas,
      clearSignature,
      getUnselectedIds,
      readImage,
      readSignature,
      onDocumentChange,
      showUploadImageModel,
      hideShowUploadImageModel,
      saveSignature,
      enableSignaturPad,
      showAddPhaseModal,
      addNewPhase,
      removeSelectedPhase,
      editNewPhase,
      closeAddPhaseModal,
      updatePhase,
      resetChecked,
      editTask,
      updateTask,
      removeTask,
      uploadLogo,
      readLogo,
      hideCreateCompanyModel,
      showCreateCompanyModel,
      createCompanyIfno,
      validateCreateCompany,
      editCompany,
      totalSendSubItem,
      totalSelectedSubItem,
      redirectToSmartContractList,
      usdPriceFormate,
      showSignaturePad,
      hideSignaturePad,
      uploadSignature,
      uploadSignatureFile,
      hideSignatureUpload,
      userSignature,
      acknowledgement,
      legalStatement,
      hasUnsavedChanges,
      originalState,
      handleBeforeUnload,
      signatureInput,
      filterUsersWithEmail,
    };
  },
});
